import { render, staticRenderFns } from "./MyFooter.vue?vue&type=template&id=01f1a86f&scoped=true"
import script from "./MyFooter.vue?vue&type=script&lang=js"
export * from "./MyFooter.vue?vue&type=script&lang=js"
import style0 from "./MyFooter.vue?vue&type=style&index=0&id=01f1a86f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_css-loader@6.11.0_webpack@5.96.1__lodash@4.17.21__2dnwv33wcshjexuxr5fqoigkvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f1a86f",
  null
  
)

export default component.exports